var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgTwitter = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21 1.5C10.2304 1.5 1.5 10.2304 1.5 21C1.5 31.7696 10.2304 40.5 21 40.5C31.7696 40.5 40.5 31.7696 40.5 21C40.5 10.2304 31.7696 1.5 21 1.5ZM0.5 21C0.5 9.67816 9.67816 0.5 21 0.5C32.3218 0.5 41.5 9.67816 41.5 21C41.5 32.3218 32.3218 41.5 21 41.5C9.67816 41.5 0.5 32.3218 0.5 21Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M28.4 16.4206C27.8709 16.6615 27.3012 16.8245 26.7036 16.8973C27.3139 16.5229 27.7821 15.9291 28.0027 15.2219C27.4314 15.5686 26.8 15.8208 26.1255 15.956C25.588 15.3675 24.8197 15 23.9694 15C22.3389 15 21.0162 16.3564 21.0162 18.0293C21.0162 18.2667 21.0415 18.4973 21.0922 18.7192C18.6369 18.5926 16.4604 17.3879 15.0024 15.553C14.748 16.002 14.6026 16.5229 14.6026 17.0776C14.6026 18.1281 15.1241 19.0555 15.917 19.5989C15.4335 19.5842 14.9771 19.4464 14.5781 19.221V19.2583C14.5781 20.7265 15.5966 21.9512 16.949 22.2286C16.7013 22.2997 16.4401 22.3352 16.1705 22.3352C15.9803 22.3352 15.7944 22.317 15.6144 22.2815C15.9905 23.4845 17.0808 24.3608 18.374 24.3842C17.3631 25.1972 16.0885 25.6817 14.7049 25.6817C14.4666 25.6817 14.2307 25.6678 14 25.6401C15.3076 26.4982 16.8611 27 18.5287 27C23.9634 27 26.9344 22.3846 26.9344 18.3811C26.9344 18.2494 26.9319 18.1177 26.9268 17.9885C27.5041 17.5612 28.0053 17.0282 28.4 16.4206Z",
    fill: "white"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgTwitter);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/twitter.d82e54bd791b49b24a7a318fbfd28f23.svg";